import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../app';
import * as DTOS from "../../FeralScan.dtos";

type HasRoleProps = {
    role: string;
}

type HasRoleActions = {}

type HasRolePropsMapped = {
    currentUser: DTOS.User;
}

type HasRoleActionsMapped = {}
type HasRoleAllPropsInherited = HasRoleProps & HasRoleActions;
type HasRoleAllPropsMapped = HasRolePropsMapped & HasRoleActionsMapped;
type HasRoleAllProps = Partial<HasRoleAllPropsMapped> & HasRoleAllPropsInherited;

interface IHasRoleState {}

class HasRole extends React.PureComponent<HasRoleAllProps, IHasRoleState> {

    checkRole(){

    }

    render() {
        const { currentUser, role } = this.props;

        return role === undefined || (currentUser && currentUser.userRoles && currentUser.userRoles.find(r => r === role)) ? this.props.children : null
    }
}

const mapStateToProps = (state: IAppState, ownProps: HasRoleAllProps): HasRolePropsMapped => {

    return {
        currentUser: state.user.currentUser
    }
}

const mapDispatchToProps = (dispatch) => { return bindActionCreators({}, dispatch)}

export default connect(mapStateToProps, mapDispatchToProps)(HasRole);